export default __webpack_public_path__ + "static/media/product-dev-icon.a2e88ac2.png";